// @ts-nocheck

import { SpecialFilterValues } from '../constants/livebar';
import { MatchEntity } from '../states/entities/matches';
import { type MatchState } from '../states/entities/matches';
import { type EntitiesSports } from '../states/entities/sports';
import { type FacetType } from '../types/facets';
import { type SportId } from '../types/sports';

export const getFacetsSports = (
  matches: Array<MatchState>,
  sportIds: Array<SportId>,
  sports: EntitiesSports,
): Array<FacetType> => {
  let nbWinaTVMatches = 0;
  const facetsBySport = matches
    .filter((k) => k)
    .reduce((acc, match) => {
      const { sportId } = match;
      if (MatchEntity.isWinamaxTvChannel(match)) {
        nbWinaTVMatches++;
      }

      // check because sports entity may be receive after match
      if (sports[sportId]) {
        if (!acc[sportId]) {
          acc[sportId] = {
            id: parseInt(sportId, 10),
            name: sports[sportId].sportName,
            count: 0,
          };
        }
        acc[sportId].count++;
      }
      return acc;
    }, {});

  const facets = sportIds.map((sportId) => facetsBySport[sportId]).filter((k) => k);

  if (nbWinaTVMatches) {
    facets.unshift({
      id: SpecialFilterValues.WINAMAX_TV_FILTER,
      count: nbWinaTVMatches,
      name: 'Streaming',
    });
  }
  return facets;
};
